import { Hammer, Trash2, Wrench, Truck, Wind, Zap, Droplets, Trees, Settings, ShieldCheck, Factory, Paintbrush, Package } from "lucide-react";
import { Button, IconGridCta, type CtaGridIcon } from "../ds/core";
import { useLocale } from "../i18n/useLocale";
import { TRIAL_PATH as TRIAL } from "../config/entrypoints";

/**
 * IndustryCta — the home closing CTA: industry icons scattered around the
 * headline on the shared IconGridCta layout. Only the industry list, the
 * market-aware copy and the CTA are page-specific here.
 */


export default function IndustryCta() {
  const { market, t } = useLocale();

  // Grey cards with a coloured icon — dark blue for the blue family, dark yellow
  // for the yellow family. Order = grid scatter (indices 0–12).
  const IND: CtaGridIcon[] = [
    { name: t("home:industryCta.industries.0"), Icon: Hammer, color: "var(--ds-gold-ink)" },     // 0 Y
    { name: t("home:industryCta.industries.1"), Icon: Zap, color: "var(--ds-gold-ink)" },        // 1 Y
    { name: t("home:industryCta.industries.2"), Icon: Trash2, color: "var(--ds-accent-deep)" },  // 2 B
    { name: t("home:industryCta.industries.3"), Icon: Wrench, color: "var(--ds-gold-ink)" },     // 3 Y
    { name: t("home:industryCta.industries.4"), Icon: Truck, color: "var(--ds-accent-deep)" },   // 4 B
    { name: t("home:industryCta.industries.5"), Icon: Droplets, color: "var(--ds-accent-deep)" },// 5 B
    { name: t("home:industryCta.industries.6"), Icon: Trees, color: "var(--ds-gold-ink)" },      // 6 Y
    { name: t("home:industryCta.industries.7"), Icon: Settings, color: "var(--ds-accent-deep)" },// 7 B
    { name: t("home:industryCta.industries.8"), Icon: Wind, color: "var(--ds-gold-ink)" },       // 8 Y
    { name: t("home:industryCta.industries.9"), Icon: ShieldCheck, color: "var(--ds-accent-deep)" }, // 9 B
    { name: t("home:industryCta.industries.10"), Icon: Factory, color: "var(--ds-gold-ink)" },   // 10 Y
    { name: t("home:industryCta.industries.11"), Icon: Paintbrush, color: "var(--ds-gold-ink)" },// 11 Y
    { name: t("home:industryCta.industries.12"), Icon: Package, color: "var(--ds-accent-deep)" },// 12 B
  ];
  const body = market === "belgium"
    ? t("home:industryCta.body.be")
    : t("home:industryCta.body.intl");

  return (
    <section className="bg-bg font-ds">
      <IconGridCta
        items={IND}
        eyebrow={
          <span className="inline-flex items-center gap-2 text-ds-14 font-semibold text-ds-ink">
            <span className="h-2 w-2 rounded-full bg-ds-accent" /> {t("home:industryCta.eyebrow")}
          </span>
        }
        title={t("home:industryCta.title")}
        body={body}
        actions={<div className="pt-2"><Button to={TRIAL} variant="solid">{t("home:industryCta.action")}</Button></div>}
      />
    </section>
  );
}
